import React from "react";

/** Icono tipo fa-adjust: cambiar estado activo/inactivo (solo pantalla Features). */
const FeatureStatusToggleIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" fill="#ffffff" stroke="#006EB7" strokeWidth="2" />
    <path
      d="M12 3a9 9 0 0 1 0 18V3z"
      fill="#006EB7"
    />
  </svg>
);

export default FeatureStatusToggleIcon;
